/**
 * NotionEditor が localStorage に持つ下書きバックアップの共有ユーティリティ。
 *
 * エディタコンポーネント本体 (`notion-editor.tsx`) から分離しているのは、
 * `notion-editor.tsx` から非コンポーネントの export を出すと Vite の
 * React Fast Refresh が効かなくなるため。
 */

/** localStorage バックアップキー (entity ごと) */
export const notionEditorBackupKey = (entityType: string, entityId: number): string =>
  `notion-editor-backup:${entityType}:${entityId}`

/**
 * localStorage 上のバックアップを削除する。
 * TODO 削除など、エンティティ自体が消える操作の直後に呼び出して、
 * 同一 ID が再採番されたときに旧本文が復活しないようにする。
 */
export const clearNotionEditorBackup = (entityType: string, entityId: number): void => {
  try {
    localStorage.removeItem(notionEditorBackupKey(entityType, entityId))
  } catch {
    // noop
  }
}
